import authActions from "../../redux/auth/actions";
import { store } from "../../redux/store";
import { updateRegistrationData } from "./registrationSetupStorage";

/** Normalized signup payload from decrypted app-api signup response */
export const getSignupPayloadFromResponse = (response) => {
  if (!response || response.status === false) {
    return null;
  }
  return response.data ?? response;
};

export const hasRegistrationAuthSession = (data) =>
  Boolean(
    data?.signupAccessToken ||
      data?.signupResponse?.access_token ||
      data?.emailCodeCheck?.access_token
  );

export const hasRegistrationSignupSession = hasRegistrationAuthSession;

export const getAccessTokenFromSignupPayload = (payload) => {
  if (!payload) return null;
  return payload.access_token ?? payload.accessToken ?? null;
};

/** Persist signup access_token to Redux + registration localStorage for later API calls */
export const persistRegistrationAuthFromSignup = (response) => {
  const payload = getSignupPayloadFromResponse(response);
  const accessToken = getAccessTokenFromSignupPayload(payload);
  if (!accessToken) {
    return null;
  }

  const user = payload.user ?? payload;

  store.dispatch(
    authActions.login({
      accessToken,
      userId: payload.id ?? user?.id,
      firstName: payload.first_name ?? user?.first_name,
      lastName: payload.last_name ?? user?.last_name,
      email: payload.email ?? user?.email,
      isLogin: true,
      state: payload.state ?? user?.state,
      insurance: payload.user_insurance?.insurance ?? user?.user_insurance?.insurance,
      isCardPresent: payload.is_card_present || false,
    })
  );

  updateRegistrationData({
    signupAccessToken: accessToken,
    signupResponse: payload,
  });

  return accessToken;
};
